import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { onDeleteWall } from "./utils";
import ReactHtmlParser from 'react-html-parser';

export default function AccordionItemSection({ feeds, wallId, deleteExtraFeed, }) {

  const getAddFeedsId = (feedsList) => {
    if (feedsList && feedsList.length > 0) {
      return feedsList.map((feed) => `${feed.id}`)
    }
  }

  const getfeedTag=(tag)=>{
   if(tag){
    if(tag.includes('<i class')){
      return <>{ReactHtmlParser(tag)}{" "}</>
       }
       return tag;
   }else return '';
  }

  return (
      <div className="card mb-0">
          <div className="card-body p-0">
            <div className="planfeed-list-head">
              <div className="row">
                <div className="col-sm-8 col-8">
                  <p className="mb-0">Feeds</p>
                </div>
                <div className="col-sm-4 col-4">
                  <p className="text-end mb-0 ">
                    <Button variant="secondary" onClick={() => onDeleteWall(() => deleteExtraFeed(wallId, getAddFeedsId(feeds))) } wallid={wallId} className="f-center w-100">
                      <span className="me-2 font-size-sm text-nowrap">Delete All</span>
                      <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'text-gray-500 fs-6'} />
                    </Button>
                  </p>
                </div>
              </div>
            </div>
            <div className="planfeed-list-body overflow-auto">
              {feeds.length > 0
                ? feeds.map((feed) => (
                  <div className={`planfeed-list-row feedarea-${feed.id}`} key={feed.id}>
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-sm-6 col-8">
                          <p className="mb-0 widget-name">
                            <a className="d-flex align-items-center">
                              <div className="symbol symbol-30 symbol-circle icon-shadow" data-toggle="tooltip" title={feed.Networkdescription}>
                                <span className="symbol-label bg-white font-size-lg"><i title={feed.Networkdescription} className={`fab ${feed.Networkicon}`} key={feed.Networkid}></i></span>
                              </div>
                              <span className="ms-3">
                                {getfeedTag(feed.feedsFilterprefix)}
                                {feed.name} {feed.feedsFiltername ? `- ${feed.feedsFiltername}` : ''}
                              </span>
                            </a>
                          </p>
                        </div>
                        <div className="col-sm-2 col-3">
                          <span className="text-center d-flex justify-content-center">
                            <span className="d-none d-sm-flex me-1">Total</span> Post: {feed.totalrecords}
                          </span>
                        </div>
                        <div className="col-sm-4 col-1">
                          <p className="text-right mb-0">
                            <Button variant="link" onClick={() => onDeleteWall(() => deleteExtraFeed(wallId, [`${feed.id}`]))}
                              className="btn-clean">
                              <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'text-gray-500 fs-6'} />
                            </Button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                : null}
            </div>
          </div>
          </div>
  );
}